// eslint-disable-next-line no-unused-vars
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useFetch from 'Hooks/useFetch';
import useUser from 'Hooks/useUser';
import { API_PROMOTIONS } from 'Constants';
import useAsyncError from 'Hooks/useAsyncError';
import useAnalytics from 'Hooks/useAnalytics';

import PromotionsComponent from 'Components/Promotions/Promotions';

const Promotions = () => {
  const { data: { email, loggedIn } } = useUser();
  const fetcher = useFetch();
  const { t } = useTranslation();
  const throwError = useAsyncError();
  const analytics = useAnalytics();

  const DEFAULT_MANUFACTURER = useMemo(() => ({ id: 'all', name: t('profile.allBrands') }), [t]);

  const [promotions, setPromotions] = useState([]);
  const [filteredPromotions, setFilteredPromotions] = useState([]);
  const [manufacturers, setManufacturers] = useState([DEFAULT_MANUFACTURER]);
  const [activeManufacturer, setActiveManufacturer] = useState(DEFAULT_MANUFACTURER.id);
  const [loading, setLoading] = useState(true);

  const getPromotions = () => {
    setLoading(true);

    fetcher(API_PROMOTIONS)
      .then(res => {
        setPromotions(res?.promotions || {});
        setManufacturers(items => [...items, ...(res?.manufacturers || {})]);
      })
      .catch(err => throwError(err))
      .finally(() => setLoading(false));
  };

  const handleActiveManufacturer = ({ id }) => {
    analytics.track('filter_promotions_by_brand', { manufacturer_id: id });
    setActiveManufacturer(id);
  };

  useEffect(() => {
    if (loggedIn) {
      getPromotions();
    }
  }, [email, loggedIn]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (activeManufacturer === null) {
      setFilteredPromotions(promotions);
      return () => {};
    }

    const filtered = promotions.filter(promo => promo.manufacturers.some(man => man.id === activeManufacturer));

    setFilteredPromotions(filtered);
  }, [activeManufacturer, promotions]);

  return (
    <PromotionsComponent
      promotions={ promotions }
      filteredPromotions={ filteredPromotions }
      manufacturers={ manufacturers }
      handleActiveManufacturer={ handleActiveManufacturer }
      activeManufacturer={ activeManufacturer }
      loading={ loading }
    />
  );
};

Promotions.displayName = 'Promotions';

export default Promotions;
